import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
var baseConfigs = [
// Global defaults
{
  domain: 'https://www.bybit.com',
  locale: 'en',
  hreflang: 'x-default'
}, {
  domain: 'https://www.bybit.com',
  locale: 'en',
  hreflang: 'en'
}, {
  domain: 'https://www.bybit.com',
  locale: 'es-ES',
  hreflang: 'es-ES'
}, {
  domain: 'https://www.bybit.com',
  locale: 'es-419',
  hreflang: 'es'
}, {
  domain: 'https://www.bybit.com',
  locale: 'es-MX',
  hreflang: 'es-MX'
}, {
  domain: 'https://www.bybit.com',
  locale: 'es-AR',
  hreflang: 'es-AR'
}, {
  domain: 'https://www.bybit.com',
  locale: 'pl-PL',
  hreflang: 'pl-PL'
}, {
  domain: 'https://www.bybit.com',
  locale: 'pt-BR',
  hreflang: 'pt-BR'
}, {
  domain: 'https://www.bybit.com',
  locale: 'pt-PT',
  hreflang: 'pt-PT'
}, {
  domain: 'https://www.bybit.com',
  locale: 'ro-RO',
  hreflang: 'ro-RO'
}, {
  domain: 'https://www.bybit.com',
  locale: 'vi-VN',
  hreflang: 'vi-VN'
}, {
  domain: 'https://www.bybit.com',
  locale: 'ja-JP',
  hreflang: 'ja-JP'
}, {
  domain: 'https://www.bybit.com',
  locale: 'zh-TW',
  hreflang: 'zh-TW'
}, {
  domain: 'https://www.bybit.com',
  locale: 'kk-KZ',
  hreflang: 'kk-KZ'
}, {
  domain: 'https://www.bybit.com',
  locale: 'ru-RU',
  hreflang: 'ru-RU'
}, {
  domain: 'https://www.bybit.com',
  locale: 'uk-UA',
  hreflang: 'uk-UA'
}, {
  domain: 'https://www.bybit.com',
  locale: 'ar-SA',
  hreflang: 'ar-SA'
},
// Bybit Global domains
{
  domain: 'https://www.bybitglobal.com',
  locale: 'zh-MY',
  hreflang: 'zh-MY'
}, {
  domain: 'https://www.bybitglobal.com',
  locale: 'en',
  hreflang: 'en-IN'
}, {
  domain: 'https://www.bybitglobal.com',
  locale: 'en',
  hreflang: 'en-NG'
}, {
  domain: 'https://www.bybitglobal.com',
  locale: 'en',
  hreflang: 'en-MY'
}, {
  domain: 'https://www.bybitglobal.com',
  locale: 'fil-PH',
  hreflang: 'tl'
}, {
  domain: 'https://www.bybitglobal.com',
  locale: 'th-TH',
  hreflang: 'th-TH'
},
// Bybit Netherlands
{
  domain: 'https://www.bybit.nl',
  locale: 'nl-NL',
  hreflang: 'nl-NL'
}, {
  domain: 'https://www.bybit.nl',
  locale: 'en-NL',
  hreflang: 'en-NL'
},
// Bybit Turkey
{
  domain: 'https://www.bybit-tr.com',
  locale: 'tr-TUR',
  hreflang: 'tr-TR'
}, {
  domain: 'https://www.bybit-tr.com',
  locale: 'en-TR',
  hreflang: 'en-TR'
},
// Bybit Global ID
{
  domain: 'https://www.bybit-global.com',
  locale: 'id-ID',
  hreflang: 'id-ID'
}];

// EU配置 - EU上线后启用
var euConfigs = [{
  domain: 'https://www.bybit.eu',
  locale: 'de-DE',
  hreflang: 'de'
}, {
  domain: 'https://www.bybit.eu',
  locale: 'pl-POL',
  hreflang: 'pl-PL'
}, {
  domain: 'https://www.bybit.eu',
  locale: 'ro-ROU',
  hreflang: 'ro-RO'
}, {
  domain: 'https://www.bybit.eu',
  locale: 'es-ESP',
  hreflang: 'es-ES'
}, {
  domain: 'https://www.bybit.eu',
  locale: 'pt-PRT',
  hreflang: 'pt-PT'
}, {
  domain: 'https://www.bybit.eu',
  locale: 'en-EU',
  hreflang: 'en-DE'
}, {
  domain: 'https://www.bybit.eu',
  locale: 'en-EU',
  hreflang: 'en-ES'
}, {
  domain: 'https://www.bybit.eu',
  locale: 'en-EU',
  hreflang: 'en-FR'
}, {
  domain: 'https://www.bybit.eu',
  locale: 'en-EU',
  hreflang: 'en-IT'
}, {
  domain: 'https://www.bybit.eu',
  locale: 'en-EU',
  hreflang: 'en-PL'
}, {
  domain: 'https://www.bybit.eu',
  locale: 'en-EU',
  hreflang: 'en-PT'
}, {
  domain: 'https://www.bybit.eu',
  locale: 'en-EU',
  hreflang: 'en-RO'
}, {
  domain: 'https://www.bybit.eu',
  locale: 'en-EU',
  hreflang: 'en-AT'
}];

// KZ配置 - bybit.com/kk-KZ/下线后启用
var kzConfigs = [{
  domain: 'https://www.bybit.kz',
  locale: 'kk-KAZ',
  hreflang: 'kk-KZ'
}, {
  domain: 'https://www.bybit.kz',
  locale: 'en-KAZ',
  hreflang: 'en-KZ'
}, {
  domain: 'https://www.bybit.kz',
  locale: 'ru-KAZ',
  hreflang: 'ru-KZ'
}];

// GE配置 - GE上线后启用
var geConfigs = [{
  domain: 'https://www.bybit-ge.com',
  locale: 'en-GEO',
  hreflang: 'en-GE'
}, {
  domain: 'https://www.bybit-ge.com',
  locale: 'ru-GEO',
  hreflang: 'ru-GE'
}, {
  domain: 'https://www.bybit-ge.com',
  locale: 'ka-GEO',
  hreflang: 'ka-GE'
}];

// ID配置 - ID上线后启用
var idConfigs = [{
  domain: 'https://www.bybit.id',
  locale: 'id-IDN',
  hreflang: 'id-ID'
}, {
  domain: 'https://www.bybit.id',
  locale: 'en-IDN',
  hreflang: 'en-ID'
}];

// const DEFAULT_SITES = ['bybit', 'eu', 'kz', 'ge', 'id'];
var defaultSites = ['bybit'];
var configMap = {
  bybit: baseConfigs,
  eu: euConfigs,
  kz: kzConfigs,
  ge: geConfigs,
  id: idConfigs
};
export var HrefLangManager = /*#__PURE__*/function () {
  function HrefLangManager() {
    _classCallCheck(this, HrefLangManager);
  }
  return _createClass(HrefLangManager, null, [{
    key: "getConfigs",
    value:
    // 源配置
    function getConfigs(sites) {
      var activeSites = sites || defaultSites;
      return activeSites.reduce(function (acc, site) {
        return acc.concat(configMap[site] || []);
      }, []);
    }
  }, {
    key: "isLocaleSegment",
    value: function isLocaleSegment(segment) {
      return segment.match(/^(\/?([a-z]{2,3}-[A-Z]{2,3}|[a-z]{2}))?$/);
    }
  }, {
    key: "processPath",
    value: function processPath(path) {
      var _this = this;
      var segments = path.split('/').filter(Boolean);
      var localeIndex = -1;
      segments.forEach(function (segment, index) {
        if (_this.isLocaleSegment(segment)) {
          localeIndex = index;
        }
      });
      return {
        segments: segments,
        localeIndex: localeIndex
      };
    }

    // 生成单个url
  }, {
    key: "generateUrl",
    value: function generateUrl(config, processedPath) {
      var segments = processedPath.segments,
        localeIndex = processedPath.localeIndex;
      var newSegments = _toConsumableArray(segments);
      if (localeIndex !== -1) {
        newSegments[localeIndex] = config.locale;
      } else {
        newSegments.unshift(config.locale);
      }
      return "".concat(config.domain, "/").concat(newSegments.join('/'));
    }

    // 生成hreflang数组
  }, {
    key: "generateHreflangArray",
    value: function generateHreflangArray(currentPath, sites) {
      var _this2 = this;
      var processedPath = this.processPath(currentPath);
      var activeConfigs = this.getConfigs(sites);
      var currentLocale = processedPath.segments[processedPath.localeIndex] || 'en';
      // 1. 查找当前语言在所有配置中的匹配项
      var matchingConfigs = activeConfigs === null || activeConfigs === void 0 ? void 0 : activeConfigs.filter(function (config) {
        return config.locale === currentLocale;
      });

      // 2. 确定canonical配置
      var canonicalConfig;
      if (matchingConfigs.length > 0) {
        // 如果找到匹配的配置，使用第一个匹配的配置
        var _matchingConfigs = _slicedToArray(matchingConfigs, 1);
        canonicalConfig = _matchingConfigs[0];
      } else {
        // 如果没有找到匹配的配置，使用主站 + en
        canonicalConfig = {
          domain: 'https://www.bybit.com',
          locale: currentLocale,
          hreflang: 'en'
        };
      }
      // 生成canonical URL
      var canonicalPath = _toConsumableArray(processedPath.segments);
      if (processedPath.localeIndex !== -1) {
        canonicalPath[processedPath.localeIndex] = canonicalConfig.locale;
      } else {
        canonicalPath.unshift(canonicalConfig.locale);
      }
      var canonicalUrl = "".concat(canonicalConfig.domain, "/").concat(canonicalPath.join('/'));

      // 生成所有的hreflang链接，但排除canonical URL对应的配置
      var hreflangLinks = activeConfigs
      // .filter((config) => {
      //   const isSameAsCanonical =
      //     config.domain === canonicalConfig.domain &&
      //     config.locale === canonicalConfig.locale;
      //   return !isSameAsCanonical;
      // })
      .map(function (config) {
        var href = _this2.generateUrl(config, processedPath);
        return {
          href: href,
          hreflang: config.hreflang,
          isCanonical: false
        };
      });

      // 添加canonical链接，同时作为x-default
      return [{
        href: canonicalUrl,
        hreflang: 'x-default',
        isCanonical: true
      }].concat(_toConsumableArray(hreflangLinks));
    }
  }, {
    key: "generateHreflangHtml",
    value: function generateHreflangHtml(hreflangArray) {
      var canonicalLink = hreflangArray.find(function (item) {
        return item.isCanonical;
      });
      var alternateLinks = hreflangArray.map(function (_ref) {
        var href = _ref.href,
          hreflang = _ref.hreflang;
        return "<link rel=\"alternate\" href=\"".concat(href, "\" hreflang=\"").concat(hreflang, "\" />");
      });
      if (canonicalLink) {
        // 将canonical放在最前面
        return "<link rel=\"canonical\" href=\"".concat(canonicalLink.href, "\" />\n").concat(alternateLinks.join('\n'));
      }
      return alternateLinks.join('\n');
    }
  }]);
}();

// get configs
export var getOriginalConfigs = function getOriginalConfigs(sites) {
  return HrefLangManager.getConfigs(sites);
};

// generate hreflang array
export var getFormattedConfigs = function getFormattedConfigs(currentPath, sites) {
  return HrefLangManager.generateHreflangArray(currentPath, sites);
};

// generate html string
export var getHreflangHtml = function getHreflangHtml(currentPath, sites) {
  return HrefLangManager.generateHreflangHtml(getFormattedConfigs(currentPath, sites));
};